import { css } from "@emotion/react";
import colors from "assets/css/colors";
import fontFamily from "assets/css/fontFamily";
import fontSize from "assets/css/fontSize";
import lineHeight from "assets/css/lineHeight";

export const popperCss = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  border-radius: 4px;
  background-color: ${colors.mainBlack};
  color: ${colors.white};
  font-family: ${fontFamily.roboto};
  font-size: ${fontSize.xs};
  line-height: ${lineHeight.xxs};
  z-index: 1002;

  &[data-popper-reference-hidden="true"] {
    opacity: 0;
    pointer-events: none;
  }
`;

export const popperTextCss = css`
  z-index: 3;
`;

export const arrowCss = css`
  position: absolute;
  width: 8px;
  height: 8px;

  &::before {
    content: "";
    position: absolute;
    width: 10px;
    height: 8.66px;
    background-color: ${colors.mainBlack};
    transform: rotate(60deg) skewX(30deg);
  }

  [data-popper-placement="right"] &,
  [data-popper-placement="left"] & {
    &:before {
      transform: rotate(-30deg) skewX(30deg);
    }
  }

  [data-popper-placement="top"] & {
    bottom: -4px;
  }

  [data-popper-placement="right"] & {
    left: -4px;
  }

  [data-popper-placement="bottom"] & {
    top: -4px;
  }

  [data-popper-placement="left"] & {
    right: -4px;
  }
`;
